import { useMemo } from 'react'

import { useAuth } from '../../auth/authContext'
import { ApiClient } from '../../data/api'
import { ortAus, type Ortstreffer } from '../../lib/geocode'
import type { LatLon } from '../../lib/types'

/** Sucht den Ort zu einer Koordinate. null heisst: dort kennt der Dienst keinen. */
export type ReverseLookup = (at: LatLon, signal?: AbortSignal) => Promise<Ortstreffer | null>

/**
 * Der Zugang zur Rückwärtssuche, an die laufende Anmeldung gebunden.
 *
 * Dieselbe Machart wie useSearchPlaces in features/stages/geocodeApi.ts, und
 * aus denselben Gründen: ein eigener Client, weil ApiClient ausser der
 * Tokenquelle keinen Zustand hält, und geprüft wird hier und nicht erst in der
 * Oberfläche - was aus dem Netz kommt, ist eine fremde Behauptung.
 */
export function useReverseLookup(): ReverseLookup {
  const { getToken } = useAuth()
  return useMemo(() => {
    const client = new ApiClient(getToken)
    return async ([lat, lon], signal) => ortAus((await client.reversePlace(lat, lon, signal)).place)
  }, [getToken])
}
